// @ts-ignore
import { adminWebUrl } from '../../environment/environment';
import React, { useEffect, useState, useRef } from 'react';
import longlogo from '../../images/landing/longlogo.svg';
import aboutus from '../../images/landing/aboutsus.svg';
import prblmbanner from '../../images/landing/manbanner.png';
import solbanner from '../../images/landing/desktopFrame.png';
import fb from '../../images/landing/fb.svg';
import insta from '../../images/landing/insta.svg';
import x from '../../images/landing/x logo.svg';
import linkin from '../../images/landing/linkin.svg';
import footerlogo from '../../images/landing/fotterlogo.svg';
import { Link, useNavigate, useParams } from 'react-router-dom';
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos';
import './styles.css'

const ReferReferUsMarkettingPage = () => {
    const [mobilemenu, setmobilemenu] = useState(false);
    const { businessCode } = useParams();
    const [activePlan, setActivePlan] = useState('Yearly'); // Default selected is 'Multi Site'
    const navigate = useNavigate();
    const scrollRef = useRef(null);

    const handleCardClick = (plan: any) => {
        setActivePlan(plan); // Update the active plan based on the clicked card
    };

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, []);

    const handleLinkClick = (
        e: React.MouseEvent<HTMLAnchorElement>,
        hash: string
    ) => {
        e.preventDefault(); // Prevent default anchor behavior
        const element = document.querySelector(hash);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        AOS.init();
    }, []);
    function handelmobileMenu() {
        setmobilemenu(!mobilemenu);
    }
    return (
        <div className="landIngPage">
            <header className='header-wrapper'>
                <div className="container">
                    <div className="landingHeader">
                        <div className="headerContent1">
                            <div className="sitelogo logo">
                                <img src={longlogo} alt="sitelogo" />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <section className="mainBanner mainBanner1">
                <div className="container">
                    <h1>
                        What’s the <span>best way</span> to market your business
                    </h1>
                    <h4>Manage your Word-of-Mouth Referrals</h4>
                    <p>
                        Get your happy clients referring you with the ReferUs
                        Network ®. When it comes to marketing your business
                        there's no one better than your happy customers and your
                        raving fans!
                    </p>
                    <div className="btnsgroups">
                        <button
                            className="btn btn-primary"
                            onClick={() => navigate(`/register/refer-refer-us/${businessCode}`)}
                        >
                            Sign Up Now
                        </button>
                        <button
                            className="btn btn-outline"
                            onClick={() => navigate('/contact-us')}
                        >
                            Find Out More
                        </button>
                    </div>
                </div>
            </section>
            <section ref={scrollRef} className="aboutus" id="about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-sm-12">
                            <div className="aboutSideImg">
                                <img src={'https://referusnetwork.com/355a578146e9eea139ca.png'} alt="aboutus" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <h2 className="headings">
                                ReferUs makes word-of-mouth referrals structured, measurable, and rewarding.
                            </h2>
                            <p>
                                Built by Aussie entrepreneurs who grew a $37M+ global brand and know the power of referrals.
                            </p>
                            <br />
                            <h2 className="headings">
                                The Problem with <span>Traditional Referrals</span>
                            </h2>
                            <p>Referrals are gold, but the way they usually happen is broken.</p>
                            <ul className="listDesign">
                                <li>Someone says “I’ll pass on your details”… then forgets.</li>
                                <li>A phone number gets lost.</li>
                                <li>An email never gets sent.</li>
                                <li>And with no way to track or follow up, opportunities slip through the cracks.</li>
                            </ul>
                            <p>
                                Even worse, most businesses only focus on people who might buy, ignoring the huge untapped group who may never be customers but could send dozens of new ones.
                                The truth? Businesses spend thousands chasing strangers when the smartest growth strategy is right in front of them:
                                Keep your customers happy, and give them (and even non-customers) a simple way to become your greatest sales force.
                            </p>
                            <br />
                            <div className="btnsgroups aboutUs">
                                <Link
                                    to={`/register/refer-refer-us/${businessCode}`}
                                    className="btn btn-primary h-auto"
                                >
                                    Sign Up Now
                                </Link>
                                <Link
                                    to="/contact-us"
                                    className="btn btn-primary h-auto"
                                >
                                    Contact Us
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Added Section */}
            <section className="solution">
                <div className="container">
                    <div className="text-center">
                        <h2 className="headings">
                            The Challenge <span>& Our Solution</span>
                        </h2>
                    </div>
                    <div className="row rowRevreseapplied">
                        <div className="col-lg-6 col-sm-12">
                            <div className="problembanner banner1">
                                <img src={prblmbanner} alt="imgs" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12 mt-30">
                            <div className="sidetextsol">
                                <h3>The Solution: ReferUs Network®</h3>
                                <h5>
                                    ReferUs takes the chaos out of word-of-mouth and makes referrals instant, structured, and trackable.
                                </h5>
                                <p>
                                    Your ReferUs platform includes:
                                </p>
                                <ul className="listDesign">
                                 <li><strong>Branded business profile</strong> – your own landing page with logo and details.</li>
                                <li><strong>Instant referrals</strong> – sent in 10 seconds from a customer’s phone.</li>
                                <li><strong>Tracking</strong> – see exactly who referred who, so nothing gets lost.</li>
                                <li><strong>Rewards</strong> – thank and incentivise the people sending you business.</li>
                                <li><strong>Dashboard</strong> – manage every referral in one place.</li>
                                </ul>

                            </div>
                            <br />
                            <div className="sidetextsol">
                                <h3>The Game-Changer: “My Network”</h3>
                                <p>
                                    Most businesses already cross-refer customers to others they know and trust, but it’s unstructured, messy, and impossible to track.
                                </p>
                                <p>
                                    ReferUs makes it simple:
                                </p>
                                <ul className="listDesign">
                                <li>Build your own referral circle with trusted businesses.</li>
                                <li>Send and receive referrals instantly.</li>
                                <li>Strengthen connections that already grow your business.</li>
                                <li>Set your own incentives to drive more referrals.</li>
                                </ul>
                            <p>
                                ReferUs becomes your <b>referral community in your pocket</b> …. organised, trackable, and effortless.
                            </p>
                            </div>
                            <br />
                        </div>
                    </div>
                    <div className="row mt-30">
                        <div className="col-lg-6 col-sm-12">
                            {/* <div className="sidetextsol">
                                <h3>The Game-Changer: <br />“My Network”</h3>
                                <p>
                                    Most businesses already cross-refer customers to others they know and trust, but it’s unstructured, messy, and impossible to track.
                                </p>
                                <p>
                                    ReferUs makes it simple:
                                </p>
                                <ul className="listDesign">
                                <li>Build your own referral circle with trusted businesses.</li>
                                <li>Send and receive referrals instantly.</li>
                                <li>Strengthen connections that already grow your business.</li>
                                <li>Set your own incentives to drive more referrals.</li>
                                </ul>
                            <p>
                                ReferUs becomes your <b>referral community in your pocket</b> …. organised, trackable, and effortless.
                            </p>
                            </div> */}
                            <div className="sidetextsol">
                                <h3>Why Businesses Love It</h3>
                                <p>
                                    ReferUs doesn’t replace your marketing … it supercharges it.

                                    It turns customers, raving fans, and business partners into your most effective sales team. Even people who’ll never buy from you directly can still send you qualified leads in seconds.

                                    And at just over $1 a day ($375 a year), one referral can pay for it many times over.
                                </p>
                                <div className='mt-30'>

                                <h3>How ReferUs Works</h3>
                                <ul className="listDesign">
                                <li><strong>Create your profile</strong> → your branded business page inside ReferUs.</li>
                                <li><strong>Build your referrer base</strong> → customers, contacts, even non-customers.</li>
                                <li><strong>Referrals in seconds</strong> → no lost numbers or forgotten emails.</li>
                                <li><strong>Track & reward</strong> → every referral is logged in your dashboard.</li>
                                </ul>

                                </div>

                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <div className="problembanner banner2">
                                <img src={solbanner} alt="imgs" />
                            </div>
                        </div>
                    </div>
                    {/* Added */}
                    {/* <div className="row rowRevreseapplied mt-30">
                        <div className="col-lg-6 col-sm-12">
                            <div className="problembanner banner1">
                                <img src={prblmbanner} alt="imgs" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <div className="sidetextsol">
                                <h3>Why Businesses Love It</h3>
                                <p>
                                    ReferUs doesn’t replace your marketing … it supercharges it.

It turns customers, raving fans, and business partners into your most effective sales team. Even people who’ll never buy from you directly can still send you qualified leads in seconds.

And at just over $1 a day ($375 a year), one referral can pay for it many times over.
                                </p>
                                <div className='mt-30'>

                                <h3>How ReferUs Works</h3>
                                <ul className="listDesign">
                                <li><strong>Create your profile</strong> → your branded business page inside ReferUs.</li>
                                <li><strong>Build your referrer base</strong> → customers, contacts, even non-customers.</li>
                                <li><strong>Referrals in seconds</strong> → no lost numbers or forgotten emails.</li>
                                <li><strong>Track & reward</strong> → every referral is logged in your dashboard.</li>
                                </ul>

                                </div>

                            </div>
                        </div>
                    </div> */}
                </div>
            </section>

            {/* new section */}
            <section className="subsplans" id="plans-section">
                <div className="container">
                    <div className="text-center">
                        <h2 className="headings">
                            One Affordable<span> Plan for Your Needs</span>
                        </h2>
                        <p className="customeheads">
                            For the cost of a small advertisement in a local
                            paper you can purchase a marketing tool that can
                            transform your business. Business can purchase the
                            system either Monthly or Yearly. White label and
                            corporate solutions also available .
                        </p>
                        <div className="cardblock cardblock1">
                            {/* <div
                                className={`cardsubs ${
                                    activePlan === 'Monthly'
                                        ? 'active aos-init aos-animate'
                                        : 'aos-init aos-animate'
                                }`}
                                data-aos="flip-left"
                                data-aos-duration="115000"
                                onClick={() => handleCardClick('Monthly')}
                            >
                                <div className="cardfirstTitle">Monthly</div>
                                <div className="cardSecondTitle">$35*</div>
                                <div className="geryblocked">
                                    <ul className="listnew">
                                        <li>ReferUs Admin Platform**</li>
                                        <li>ReferUs Mobile application</li>
                                        <li>ReferUs Network Platform</li>
                                        <li>
                                            Personalised QR Code and URL to
                                            promote on social media
                                        </li>
                                    </ul>
                                    <div className="text-center">
                                        <button
                                            onClick={() =>
                                                navigate(`/register/refer-refer-us/${businessCode}`, {
                                                    state: {
                                                        selectedPlan: 'monthly',
                                                    },
                                                })
                                            }
                                            className="chooseplan"
                                        >
                                            Choose Plan
                                        </button>
                                    </div>
                                </div>
                            </div> */}
                            <div
                                className={`cardsubs ${
                                    activePlan === 'Yearly'
                                        ? 'active aos-init aos-animate'
                                        : 'aos-init aos-animate'
                                }`}
                                data-aos="flip-left"
                                data-aos-duration="115000"
                                onClick={() => handleCardClick('Yearly')}
                            >
                                <div className="cardfirstTitle">Yearly</div>
                                <div className="cardSecondTitle">$375*</div>
                                <div className="geryblocked">
                                    <ul className="listnew">
                                        <li>ReferUs Admin Platform**</li>
                                        <li>ReferUs Mobile application</li>
                                        <li>ReferUs Network Platform</li>
                                        <li>
                                            Personalised QR Code and URL to
                                            promote on social media
                                        </li>
                                    </ul>
                                    <div className="text-center">
                                        <button
                                            onClick={() =>
                                                navigate(`/register/refer-refer-us/${businessCode}`, {
                                                    state: {
                                                        selectedPlan: 'yearly',
                                                    },
                                                })
                                            }
                                            className="chooseplan"
                                        >
                                            Choose Plan
                                        </button>
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                        <p className="customeheads1">
                            * Tax not included <br />
                            <p>
                                ** Monthly: allows for 500 referrers, then
                                $15.00 for every 500 referrers <br />
                                Yearly: allows for 500 referrers, then $180.00
                                for every 500 referrers
                            </p>
                        </p>
                    </div>
                </div>
            </section>
            <footer>
                <div className="outerfooter">
                    <div className="container">
                        <div className="whitefooters">
                            <div className="textparts">
                                ReferUs Network :{' '}
                                <span>Grow your business with ReferUs</span>
                            </div>
                            <Link className="btn btn-primary h-auto" to={`/register/refer-refer-us/${businessCode}`}>
                                Sign Up Now
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="fottercontent">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-sm-12">
                                <div className="sitelogo">
                                    <img src={footerlogo} alt="sitelogo" />
                                </div>
                                <p>
                                    Get your happy clients referring you with
                                    ReferUs
                                </p>
                                <div className="socialIcons">
                                    <a href="#" target="_blank">
                                        <img src={fb} alt="facebook" />
                                    </a>
                                    <a href="#" target="_blank">
                                        <img src={insta} alt="instagram" />
                                    </a>
                                    <a href="#" target="_blank">
                                        <img src={x} alt="x" />
                                    </a>
                                    <a href="#" target="_blank">
                                        <img src={linkin} alt="LinkedIn" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-6 links">
                                <h3>Quick Links</h3>
                                <Link
                                    to="#about"
                                    onClick={(e) =>
                                        handleLinkClick(e, '#about')
                                    }
                                >
                                    About
                                </Link>
                                {/* <Link
                                    to="/"
                                    onClick={(e) =>
                                        handleLinkClick(e, '#process')
                                    }
                                >
                                    Process{' '}
                                </Link> */}
                                <Link
                                    to="/"
                                    onClick={(e) =>
                                        handleLinkClick(e, '#plans-section')
                                    }
                                >
                                    Plans
                                </Link>
                                <Link to="/contact-us">Contact</Link>
                                <Link to="/platform-registration">Platform Registration</Link>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-6 links">
                                <h3>Contact </h3>
                                <Link to="/contact-us">Contact Us</Link>
                                <a
                                    href="/privacy-policy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Privacy Policy
                                </a>
                                <a
                                    href="/terms-and-conditions"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Terms & Conditions
                                </a>

                                <Link
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault(); // Prevents React Router's internal navigation
                                        window.open(
                                            `${adminWebUrl}/login`,
                                            '_blank'
                                        );
                                    }}
                                >
                                    Sign In
                                </Link>
                                <Link to={`/register/refer-refer-us/${businessCode}`}>Register</Link>
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <h3>Subscribe Our Newsletter </h3>
                                <div className="subscriptionletter">
                                    <form>
                                        <input
                                            type="text"
                                            placeholder="Enter Your Email Here"
                                        />
                                        <button className="arrow button">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="25"
                                                viewBox="0 0 24 25"
                                                fill="none"
                                            >
                                                <path
                                                    d="M21.5 3.33984L14.85 22.3398L11.05 13.7898L2.5 9.98984L21.5 3.33984Z"
                                                    stroke="#F47523"
                                                    stroke-width="2"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M21.4998 3.33984L11.0498 13.7898"
                                                    stroke="#F47523"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="text-center copyright">
                        © {new Date().getFullYear()} ReferUs , All rights
                        reserved
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default ReferReferUsMarkettingPage;
